export default __webpack_public_path__ + "static/media/Vedika Mehrotra.393dae4b.jpg";